export default __webpack_public_path__ + "static/media/Programming3.3001ed5e.png";